import styled from 'styled-components';

const Main = styled.main`
    grid-area: main;
    min-height: 90vh;
    background-color: #393431;
    padding: 2%;
`;

export default Main;